import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { applyThemeVars, darkTheme, lightTheme } from './darkTheme';

const ThemeContext = createContext({
  theme: lightTheme,
  mode: 'light',
  toggleMode: () => {},
  setMode: () => {},
});

const STORAGE_KEY = 'dasna-theme-mode';

export function ThemeProvider({ children }) {
  const [mode, setModeState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'light' || saved === 'dark') return saved;
    } catch { /* ignore */ }
    return 'light';
  });

  const theme = mode === 'light' ? lightTheme : darkTheme;

  useEffect(() => {
    applyThemeVars(theme);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch { /* ignore */ }
  }, [mode, theme]);

  const setMode = useCallback((next) => {
    setModeState(next === 'light' ? 'light' : 'dark');
  }, []);

  const toggleMode = useCallback(() => {
    setModeState((m) => (m === 'light' ? 'dark' : 'light'));
  }, []);

  const value = useMemo(
    () => ({ theme, mode, toggleMode, setMode }),
    [theme, mode, toggleMode, setMode],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
